import React from 'react'

const Desconhecido = () => {
  return (
    <div>
      <h1>Página Desconhecida!</h1>
    </div>
  )
}

export default Desconhecido
